import { PageContainer } from '@flash-tecnologia/hros-web-ui-v2';
import styled from 'styled-components';

export const StyledPageContainer = styled(PageContainer)`
  && {
    height: 100%;
    gap: ${({ theme }) => theme.spacings.m};
    margin-top: ${({ theme }) => theme.spacings.m};
  }
`;

export const StyledContentContainer = styled(PageContainer)`
  && {
    gap: ${({ theme }) => theme.spacings.m};
  }
`;

export const RowContainer = styled.div<{ isReponsive?: boolean }>`
  display: flex;
  flex-direction: row;
  ${({ isReponsive }) =>
    isReponsive &&
    `
    @media (max-width: 1250px) {
      flex-direction: column;
      align-items: center;
    }

  `}
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
